package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.SystemRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

class RemoteSystemRepository(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val authRepository: AuthRepository,
) : SystemRepository {
    override suspend fun today(): LocalDate = LocalDate.parse(get<SystemTodayDto>("/system/today").date)

    private suspend inline fun <reified T> get(path: String): T = request { httpClient.get(baseUrl + path) { authorize() } }.body()

    private suspend inline fun request(
        crossinline call: suspend () -> HttpResponse,
    ): HttpResponse {
        val response = call()
        if (!response.status.isSuccess()) {
            val message =
                runCatching {
                    Json { ignoreUnknownKeys = true }
                        .decodeFromString<SystemApiErrorDto>(response.bodyAsText())
                        .message
                }.getOrNull()
            error(message ?: "HTTP ${response.status.value}")
        }
        return response
    }

    private fun HttpRequestBuilder.authorize() {
        authRepository.session.value?.token?.let { token ->
            header(HttpHeaders.Authorization, "Bearer $token")
        }
    }
}

@Serializable
private data class SystemTodayDto(
    val date: String,
)

@Serializable
private data class SystemApiErrorDto(
    val message: String? = null,
)
